module.exports = __webpack_public_path__ + "img/ard-logo.1ea0f887.jpg";